import { render, staticRenderFns } from "./LineaNegocioIndex.vue?vue&type=template&id=2ed38adb"
import script from "./LineaNegocioIndex.vue?vue&type=script&lang=js"
export * from "./LineaNegocioIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports